"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const ModalHeader_1 = __importDefault(require("react-bootstrap/ModalHeader"));
const Modal_module_css_1 = __importDefault(require("../public/Modal.module.css"));
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const Modal = (props) => {
    const backdrop = props.actionRequired ? "static" : true;
    const closeButton = props.actionRequired ? false : true;
    const dialogClassName = props.dialogClassName ? props.dialogClassName : "";
    const contentClassName = props.contentClassName ? props.contentClassName : "";
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Modal_1.default, { dialogClassName: `${dialogClassName} ns-rounded-large p-4`, contentClassName: `${contentClassName} ${Modal_module_css_1.default.modal} ns-rounded-large p-4`, show: props.isShown, onHide: props.onClose, backdrop: backdrop, centered: props.centered, "data-testid": props.testid, "data-cy": props.dataCy },
            react_1.default.createElement(ModalHeader_1.default, { className: `${Modal_module_css_1.default.modal_header}` },
                props.header ?
                    react_1.default.createElement(Modal_1.default.Title, null, props.header)
                    :
                        react_1.default.createElement(Modal_1.default.Title, { className: `${Modal_module_css_1.default.modal_title} ns-font-family-bold` }, props.headerText),
                closeButton ?
                    react_1.default.createElement("div", { className: `${Modal_module_css_1.default.close_button} position-absolute top-0 start-100 translate-middle`, onClick: props.onClose, "data-cy": "modalCloseBtn" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faXmark, style: { color: "var(--info-color)" } }))
                    :
                        react_1.default.createElement(react_1.default.Fragment, null)),
            react_1.default.createElement(Modal_1.default.Body, null, props.body),
            react_1.default.createElement(Modal_1.default.Footer, { className: Modal_module_css_1.default.modal_footer }, props.footer))));
};
exports.default = Modal;
